import * as React from "react";
import type { SVGProps } from "react";
const SvgInvoice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      fill="#23F6E7"
      d="M20.955 5.038A3.04 3.04 0 0 0 17.918 2H6.038A3.04 3.04 0 0 0 3 5.038v15.567c.015.42.224.808.584 1.048l1.675 1.123c.464.299 1.048.299 1.512 0l2.244-1.497 2.244 1.497c.464.299 1.048.299 1.512 0l2.244-1.497 2.244 1.497c.464.299 1.048.299 1.512 0l1.675-1.123c.345-.24.554-.629.554-1.048V5.038zm-4.653 10.418H7.743v-2.11h8.559zm0-3.667H7.743v-2.11h8.559zm0-3.532H7.743v-2.11h8.559z"
    />
  </svg>
);
export default SvgInvoice;
